module.exports = __webpack_public_path__ + "static/img/logo_SJ.24ccc38f.png";